import { render, staticRenderFns } from "./zmdet_t.vue?vue&type=template&id=fc921d4c&scoped=true&"
import script from "./zmdet_t.vue?vue&type=script&lang=js&"
export * from "./zmdet_t.vue?vue&type=script&lang=js&"
import style0 from "./zmdet_t.vue?vue&type=style&index=0&id=fc921d4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc921d4c",
  null
  
)

export default component.exports